import {
  required,
  requiredIf,
  email,
  integer,
  maxLength,
  minLength
} from 'vuelidate/lib/validators';
import { MOBILE_REGEX, doesValuePassRegex } from 'ecx.saigon.ui.common';
import { MATCHES_ORGANISATIONS_OPTIONS } from '../../utils/constants';

export default {
  formUser: {
    companyName: {
      required: requiredIf(function (vm) {
        return vm.noCorporateEmail;
      })
    },
    companyEmail: {
      email,
      required: requiredIf(function (vm) {
        return !vm.noCorporateEmail;
      })
    },
    postcode: {
      required,
      integer,
      maxLength: maxLength(4),
      minLength: minLength(4)
    },
    contactNumber: {
      required,
      mobileNumber: (value) => doesValuePassRegex(value, MOBILE_REGEX.au)
    }
  },
  selectedOrganisation: {
    isValid: function (value, vm) {
      if (
        !vm.user.hasOrganisation &&
        vm.user.profile.matchesOrganisations ===
          MATCHES_ORGANISATIONS_OPTIONS.multiple
      ) {
        return Boolean(vm.selectedOrganisation.value);
      }
      return true;
    }
  },
  corporateEmail: ['formUser.companyEmail'],
  companyName: ['formUser.companyName'],
  postcode: ['formUser.postcode'],
  contactNumber: ['formUser.contactNumber'],
  organisationSelection: ['selectedOrganisation'],
  user: ['formUser']
};
